import { createContext, type ReactNode, useContext, useMemo } from 'react';
import { GQLInteractionType } from 'src/generated/graph-api';
import type { CoverSheetConfig } from '../configurations/types';

interface CoverSheetContextInterface {
  interactionId: string; // URL id
  interactionType: GQLInteractionType;
  config?: CoverSheetConfig;
  ownerId?: string;
}

const CoverSheetContext = createContext<CoverSheetContextInterface>({
  interactionId: '',
  interactionType: GQLInteractionType.listing,
  config: undefined,
});

export function useCoverSheetContext() {
  return useContext(CoverSheetContext);
}

interface Props {
  interactionId: string;
  interactionType: GQLInteractionType;
  config?: CoverSheetConfig;
  ownerId?: string;
  children: ReactNode;
}

export const CoverSheetProvider = ({
  interactionId,
  interactionType,
  config,
  ownerId,
  children,
}: Props) => {
  const contextValue = useMemo<CoverSheetContextInterface>(
    () => ({
      interactionId,
      interactionType,
      config,
      ownerId,
    }),
    [interactionId, interactionType, config, ownerId],
  );

  return (
    <CoverSheetContext.Provider value={contextValue}>
      {children}
    </CoverSheetContext.Provider>
  );
};
